<p>group-title works!</p>
{{band.name}}
{{band.genre}}